import { Component, ViewChild } from '@angular/core';
import { ModalController, NavController, NavParams, AlertController, Platform, ToastController } from 'ionic-angular';
import { CajaProvider } from '../../providers/caja/caja';
import { LoadingController } from 'ionic-angular';
import { MesasProvider } from '../../providers/mesas/mesas';
import { DenominacionesProvider } from '../../providers/denominaciones/denominaciones';
import { CompaniasProvider } from '../../providers/companias/companias';
import { AuthService } from '../../providers/auth-service';
import { ProductosProvider } from '../../providers/productos/productos';
import { ProductosPorGruposProvider } from '../../providers/productos-por-grupos/productos-por-grupos';
import { PushProvider } from '../../providers/push/push';
import { UtilsProvider } from '../../providers/utils/utils';
import { ClientesProvider } from '../../providers/clientes/clientes';
import { HomePage } from '../../pages/home/home';
import { InformesProvider } from '../../providers/informes/informes';

@Component({
  selector: 'ia',
  templateUrl: 'ia.html',
  providers: [AuthService, CajaProvider, MesasProvider, DenominacionesProvider, CompaniasProvider, ProductosPorGruposProvider, PushProvider]
})
export class IaComponent {
  consulta: string = '';
  resultado: any = null;

  tablasDisponibles = [ "ventasDiarias", "clientes","comandas","productos","productosElaborados",
    "productosElaboradosContenido", "cuentasPorCobrar", "cargos",
    "actualizacionInventario","companias","proveedores","comandasEliminadas","usuarios",
    "logFacturasElectronicas","mesas"];

  camposDisponibles = {
    "actualizacionInventario": ["actualizacionInventarioId", "fechaActualizo", "usuarioActualizo", "companiasId", "existenciasActualizadas"],
    "cargos": ["cargosId", "codigoCargo", "nombreCargo", "companiasId"],
    "clientes": ["clientesId", "tipoIdentificacion", "identificacion", "digito", "fechaExpedicion", "primerApellido", "segundoApellido", "primerNombre", "segundoNombre", "nombreCompleto", "fechaIngreso", "estado", "numeroTelefono", "direccion", "companiasId", "correoElectronico", "entidadesId", "fechaNacimiento", "edad", "numeroTelefono2", "foto", "genero", "habilitarParaCredito", "empresa", "cargo", "salario", "ws"],
    "comandas": ["comandasId", "cantidad", "gruposProductosId", "imagen", "nombreProducto", "numeromesa", "productosId", "tipoProducto", "valorImpuesto", "valorProducto", "valorVenta", "clientesId", "valorTotalVenta", "totalPagado", "usuariosId", "valorTotalDevolver", "centroDeCostosId", "codigoCentroDeCosto", "fecha", "domicilio", "estado", "Uuid", "codigo", "color", "descripcion", "cantidadImpresion", "companiasId", "porcentajeImpuesto", "turno", "numeroPersona", "incluirServicio", "formaDePago", "imprimirProducto", "imprimirGeneral", "centroDeCostosGestionId", "consecutivo", "esUnTurnoGuardado", "emiteSonido", "domicilioCerrado"],
    "comandasEliminadas": ["comandasEliminadasId", "comandasId", "cantidad", "gruposProductosId", "imagen", "nombreProducto", "numeromesa", "productosId", "tipoProducto", "valorImpuesto", "valorProducto", "valorVenta", "clientesId", "valorTotalVenta", "totalPagado", "usuariosId", "valorTotalDevolver", "centroDeCostosId", "codigoCentroDeCosto", "fecha", "domicilio", "estado", "Uuid", "codigo", "color", "descripcion", "cantidadImpresion", "companiasId", "porcentajeImpuesto", "turno", "numeroPersona", "incluirServicio", "formaDePago", "imprimirProducto", "imprimirGeneral", "centroDeCostosGestionId"],
    "companias": ["companiasId", "codigoCompania", "nitCompania", "nombreCompania", "direccion", "telefonos", "tipoRegimen", "nombreComercial", "municipio", "resolucionDian", "prefijoDian", "manejaFacturaElectronica", "setPruebasFacturaElectronica", "suscriptorDian", "estado"],
    "cuentasPorCobrar": ["cuentasPorCobrarId", "numeroFactura", "clientesId", "fecha", "valorFactura", "valorPagado", "companiasId", "usuariosId", "planSepare", "periodo", "tasaPeriodo", "fechaUltimoAbono", "fechaUltimoCalculo", "diasMora", "diasMoraSinHolgura"],
    "usuarios": ["usuariosId", "codigoUsuario", "nombreUsuario", "cargosId", "administrador", "correoElectronico", "clave", "intentosClaves", "ultimoCambioClave", "diasCambioClave", "cambiaClaveProximoInicioSesion", "estado", "desconect", "companiasPrincipalesId", "clavePedidosSalon"],
    "ventasDiarias": ["ventasDiariasId", "fechaVenta", "consecutivo", "clientesId", "productoId", "tipoProducto", "cantidad", "valorUnitario", "valorImpuesto", "ubicacionesPorSalonesId", "usuariosId", "companiasId", "totalPagado", "tipoVenta", "porcentajeImpuesto", "ventaDiariaUuid", "valorICA", "valorReteICA"]
,    "productos": ["productosId", "codigoProducto", "nombreProducto", "descripcion", "imagen", "costo", "valorVenta", "existenciasMinimas", "existenciasActuales", "visualizaEnCaja", "controlaEnInventario", "companiasId", "tipoImpuesto", "valorImpuesto", "centroDeCostosId", "imagenLocal", "codigoBarra", "ubicacionId", "contenedorId", "estado", "prioridad", "unidad", "nombreImpresora", "camposAdicionales", "linea", "categoria", "referencia", "talla", "color", "marca", "uuid", "manejaIca", "manejaReteIca"],
    "productosElaborados": ["productosElaboradosId", "codigoProductoElaborado", "nombreProductoElaborado", "imagen", "valorVenta", "companiasId", "tipoImpuesto", "valorImpuesto", "imagenLocal", "valorCosto", "codigoBarra", "ubicacionId", "estado", "prioridad", "unidad", "nombreImpresora", "centroDeCostosId", "camposAdicionales", "linea", "categoria", "referencia", "talla", "color", "marca", "uuid", "manejaIca", "manejaReteIca"]
}

  sugerencias: { tipo: string; nombre: string }[] = [];
  seleccionados: string[] = [];
  anchoBuscador: number = 200; // Ancho inicial en píxeles
  @ViewChild('inputBuscador') inputBuscador: any;
  // Mapa de sinónimos para tablas
  sinonimosTablas = {
    compra: 'ventasDiarias',
    compras: 'ventasDiarias',
    pedidos: 'comandas',
    personas: 'clientes',
    cliente: 'clientes',
    items: 'productos',
    trabajadores: 'usuarios'
  };

  // Mapa de sinónimos para campos
  sinonimosCampos = {
    nombre: 'nombreCompleto',
    apellido: 'primerApellido',
    cedula: 'identificacion',
    id: 'identificacion',
    correo: 'correoElectronico',
    email: 'correoElectronico',
    total: 'totalPagado',
    cantidadVendida: 'cantidad',
    precioUnitario: 'precio',
    stockDisponible: 'stock',
    fecha: "fechaVenta",
    codigo: "codigoUsuario",
    existencia: "existenciasActuales"
  };
  consultasGuardadas: ConsultaGuardada[] = [];
  consultasPaginadas: ConsultaGuardada[] = [];
  paginaActual: number = 0;
  tamanioPagina: number = 10;
  mostrarHistorial: boolean = false;
  consultasIa: boolean = false;
  datosDinamicos: any[] = [];
  columnas: string[] = [];
  imagen:string = ''
  imagenAmpliada = false;
  imagenAmpliadaDos: string | null = null;
  videosRelacionados = []
  listaVideos =  [
    {
      "titulo": "Productos",
      "id": 3,
      "nombre": "ProductosPage",
      "ruta": "ProductosElaboradosPage",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/creaci%C3%B3n+de+productos.mp4",
      "descripcion": "crear un producto para luego poder venderlo en caja",
      "imagenes_asociadas": [],
      "clave": "crear producto, agregar producto, vender producto, ayuda caja"
    },
    {
      "titulo": "Productos elaborados",
      "id": 3,
      "nombre": "ProductosElaboradosPage",
      "ruta": "ProductosElaboradosPage",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/creaci%C3%B3n+de+productos+elaborados.mp4",
      "descripcion": "crear un productos elaborados para luego poder venderlo en caja",
      "imagenes_asociadas": [],
      "clave": "crear producto elaborado, ayuda productos, vender productos"
    },
    {
      "titulo": "Chat bot con IA",
      "id": 3,
      "nombre": "chatbotconia",
      "ruta": "chatbotconia",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/integraci%C3%B3n+rocket+chat+-+IA+-+chatbot+-+SAN.mp4",
      "descripcion": "chat bot con IA integrado con rocket chat facebook, whatsapp, instagram etc.",
      "imagenes_asociadas": [],
      "clave": "IA, chatbot, asistencia automática, integración chat"
    },
    {
      "titulo": "cierre caja",
      "id": 3,
      "nombre": "chatbotconia",
      "ruta": "chatbotconia",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/cierre.mp4",
      "descripcion": "Genera el cierre diario, cierra la caja y realiza el arqueo de manera rápida y sencilla.",
      "imagenes_asociadas": [],
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Actualizar SAN",
      "id": 3,
      "nombre": "actualizarversionsan",
      "ruta": "actualizarversionsan",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/actualizarSAN.mp4",
      "descripcion": "como actualizar la versión de SAN",
      "imagenes_asociadas": [],
      "clave": "actualizar SAN, nueva versión, actualizar sistema"
    },
    {
      "titulo": "Enviar factura electrónica DIAN",
      "id": 3,
      "nombre": "actualizarversionsan",
      "ruta": "actualizarversionsan",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/factura+electronica.mp4",
      "descripcion": "como enviar una factura electrónica a la Dian",
      "imagenes_asociadas": [],
      "clave": "factura electrónica, enviar a DIAN, facturación, impuestos"
    },
    {
      "titulo": "Gestión mesas",
      "id": 3,
      "nombre": "actualizarversionsan",
      "ruta": "actualizarversionsan",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/gestion+mesas.mp4",
      "descripcion": "como atender una mesa en el salón",
      "imagenes_asociadas": [],
      "clave": "mesas, atender clientes, tomar pedidos, asignar mesa"
    },
    {
      "titulo": "Cuando no imprime SAN",
      "id": 3,
      "nombre": "actualizarversionsan",
      "ruta": "actualizarversionsan",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/imprimir.mp4",
      "descripcion": "la impresora no funciona con SAN, dejo de imprimir",
      "imagenes_asociadas": [
        "https://afnarqui.s3.us-east-1.amazonaws.com/videos/imagenes/webdirectprint1.png",
        "https://afnarqui.s3.us-east-1.amazonaws.com/videos/imagenes/webdirectprint2.png"
      ],
      "clave": "impresora, problema impresión, error ticket, no imprime"
    },
    {
      "titulo": "Instalar SAN",
      "id": 3,
      "nombre": "actualizarversionsan",
      "ruta": "actualizarversionsan",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/instalarSAN.mp4",
      "descripcion": "como atender una mesa en el salón, instalar la apk de SAN",
      "imagenes_asociadas": [],
      "clave": "instalar aplicación, instalar sistema, configuración inicial"
    },
    {
      "titulo": "Enviar pos electrónica DIAN",
      "id": 3,
      "nombre": "actualizarversionsan",
      "ruta": "actualizarversionsan",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/pos+electronico.mp4",
      "descripcion": "como enviar un pos electrónica a la Dian",
      "imagenes_asociadas": [],
      "clave": "pos electrónico, facturación, DIAN, enviar POS"
    },
    {
      "titulo": "Agregar los productos a la caja",
      "id": 3,
      "nombre": "actualizarversionsan",
      "ruta": "actualizarversionsan",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/productos+por+grupo+drag.mp4",
      "descripcion": "como agrgar un producto en SAN para que se vea en la caja, produtos por grupos drag",
      "imagenes_asociadas": [],
      "clave": "productos en caja, visualización caja, configuración productos"
    },
    {
      "titulo": "Reemprimir recibo de caja",
      "id": 3,
      "nombre": "actualizarversionsan",
      "ruta": "actualizarversionsan",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "icon": "globe",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/reemprimir+recibo+de+caja.mp4",
      "descripcion": "Permite imprimir los recibos de caja ya generados ne SAN,imprimir venta reemprimir recibo caja",
      "imagenes_asociadas": [],
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Balance general",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/balance+general.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Permite generar un informe consolidado del estado financiero del negocio, incluyendo ingresos, egresos y resultados totales. Palabras clave: balance, finanzas, informe, egresos, ingresos.",
      "clave": "estado financiero, ingresos, egresos, resumen contable"
    },
    {
      "titulo": "Cargar stock",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/cargar+stock.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Facilita la actualización del inventario para mantener un control preciso de las existencias de productos. Palabras clave: inventario, stock, productos, actualización.",
      "clave": "actualizar stock, inventario, agregar existencias"
    },
    {
      "titulo": "Crear cargos",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/crear+cargos.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Permite definir roles o cargos con permisos específicos para organizar las tareas de los usuarios del sistema. Palabras clave: roles, permisos, usuarios, cargos.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Crear clientes",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/crear+cliente.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Ofrece la posibilidad de registrar información detallada de clientes para seguimiento y gestión de ventas. Palabras clave: clientes, registro, ventas, gestión.",
      "clave": "registrar cliente, agregar clientes, nuevo cliente"
    },
    {
      "titulo": "Crear cuentas por cobrar",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/crear+cuenta+por+cobrar.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Gestiona las deudas pendientes de los clientes, permitiendo un seguimiento claro de los pagos. Palabras clave: cuentas, cobrar, deudas, pagos, clientes.",
      "clave": "cuentas por cobrar, pagos pendientes, gestionar deudas"
    },
    {
      "titulo": "Crear domicilio en turno",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/crear+domicilios+en+turno.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Permite gestionar pedidos a domicilio realizados durante los turnos de operación. Palabras clave: domicilio, turnos, pedidos, gestión.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Crear grupos",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/crear+grupos.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Facilita la creación de categorías o familias de productos para filtrar y organizar las ventas de manera más eficiente. Palabras clave: grupos, categorías, familias, productos, ventas.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Crear producto rápido",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/crear+producto+rapido.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Habilita la creación rápida de productos para integrarlos al sistema de ventas sin configuraciones avanzadas. Palabras clave: productos, rápido, creación, ventas.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Crear productos elaborados contenido",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/crear+productos+elebarodos+contenido.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Permite crear productos complejos que requieren una lista de ingredientes o componentes para su elaboración. Palabras clave: productos, elaboración, ingredientes, componentes, complejos.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Crear proveedores",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/crear+proveedores.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Permite registrar información de proveedores para gestionar compras y relaciones comerciales. Palabras clave: proveedores, registro, compras, relaciones.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Crear usuarios",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/crear+un+usuario.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Facilita la creación de nuevos usuarios en el sistema, asignándoles permisos y roles específicos. Palabras clave: usuarios, creación, permisos, roles.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Dar permiso a un usuario para ingresar a SAN",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/dar+permiso+a+un+usuario+para+ingresar+a+la+aplicacion.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Permite asignar acceso a usuarios específicos para que ingresen al sistema administrativo SAN. Palabras clave: permisos, usuarios, acceso, SAN.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Descripción en turno",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/descripciones+en+turno.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Registra y organiza notas o descripciones relacionadas con los turnos en curso. Palabras clave: descripción, turnos, notas, organización.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Devolver factura",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/devolver+factura.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Permite gestionar devoluciones de productos o servicios, actualizando el inventario y las cuentas. Palabras clave: devoluciones, factura, productos, inventario, cuentas.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Egresos y ingresos",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/egresos+y+ingresos.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Registra y categoriza todas las transacciones de ingresos y egresos para un control financiero detallado. Palabras clave: egresos, ingresos, transacciones, finanzas, registro.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Facturas enviadas a la DIAN",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/facturas+enviadas+a+la+dian.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Muestra un historial de las facturas electrónicas enviadas a la DIAN, cumpliendo con las normativas fiscales. Palabras clave: facturas, DIAN, historial, normativas, fiscales.",
      "clave": "facturación, impuestos, DIAN, enviar facturas"
    },
    {
      "titulo": "Parámetros caja",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/parametros+caja.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Configura ajustes específicos de la caja para adaptarse a las necesidades operativas del negocio. Palabras clave: parámetros, caja, ajustes, configuración.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Parámetros generales",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/parametros+generales.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Permite establecer configuraciones generales del sistema para personalizar su funcionamiento. Palabras clave: parámetros, generales, configuración, sistema, personalización.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Permisos por cargo",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/permisos+por+cargo.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Define y gestiona los permisos asignados a cada cargo o rol dentro del sistema. Palabras clave: permisos, cargos, roles, gestión.",
      "clave": "roles, permisos, acceso restringido"
    },
    {
      "titulo": "Formas de pago",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/varias+formas+de+pago.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Administra múltiples métodos de pago como efectivo, tarjetas o transferencias para mayor flexibilidad en las ventas. Palabras clave: pagos, efectivo, tarjetas, transferencias, métodos.",
      "clave": "tarjeta, efectivo, pago en línea, facturación"
    },
    {
      "titulo": "Venta desde turno",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/venta+desde+turno.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Facilita la gestión de ventas realizadas directamente desde los turnos de operación. Palabras clave: ventas, turno, gestión, operación.",
      "clave": "ventas en turno, proceso venta, caja rápida"
    },
    {
      "titulo": "Dividir el pago de una cuenta",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/dividir+cuenta.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Permite dividir el costo de una venta entre varios clientes o métodos de pago, facilitando la flexibilidad en el cierre de operaciones. Palabras clave: dividir, cuenta, pagos, flexibilidad, clientes.",
      "clave": "dividir cuenta, pago compartido, clientes, facturación"
    },
    {
      "titulo": "Formas de pago",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/formas+de+pago.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Explora cómo manejar distintas formas de pago, como efectivo, tarjetas o transferencias, para brindar una experiencia más conveniente. Palabras clave: pagos, métodos, tarjetas, efectivo, transferencias.",
      "clave": "tarjeta, efectivo, pago en línea, facturación"
    },
    {
      "titulo": "Aplicar descuento",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/aplicar+descuento.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Aprende a aplicar descuentos en las ventas para ofrecer promociones y mejorar la experiencia del cliente. Palabras clave: descuento, promociones, ahorro, ventas, clientes, porcentaje",
      "clave": "descuento, rebaja, oferta, promoción"
    },
    {
      "titulo": "Incluir propina",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/incluirpropina.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Descubre cómo añadir una propina fija o un porcentaje al total de la cuenta para facilitar el pago de servicios. Palabras clave: propina, porcentaje, pago, servicio, cuenta.",
      "clave": "propina, porcentaje extra, dar propina, servicio"
    },
    {
      "titulo": "Asignar clave en pedidos salón",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/asignar-clave-en-pedidos-salon.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Aprende cómo configurar y utilizar una clave de acceso en pedidos salón para restringir el acceso y asegurar la gestión de ventas, domicilios y turnos. Palabras clave: clave, seguridad, pedidos, salón, acceso, ventas, turnos.",
      "clave": "clave seguridad, pedidos salón, acceso restringido"
    },
    {
      "titulo": "Gestión de ventas en Tendero",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/tendero.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Descubre cómo gestionar ventas en Tendero, crear clientes, asociarlos a una venta y enviar la factura electrónica a la DIAN. Además, aprende a actualizar una venta con un cliente para garantizar un proceso de facturación eficiente. Palabras clave: ventas, Tendero, clientes, facturación electrónica, DIAN, actualización de venta.",
      "clave": "soporte, ayuda, error, asistencia"
    },
    {
      "titulo": "Cambio de precio y valor en los productos",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/cambiodeprecioyvalorenlosproductos.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Aprende a modificar el precio y valor de los productos en el sistema. Descubre cómo realizar ajustes para diferentes escenarios de venta y garantizar un control eficiente de precios. Palabras clave: precios, productos, cambio de valor, ventas, gestión de inventario. caja vertical",
      "clave": "ajustar precio, modificar valor, gestión precios"
    },
    {
      "titulo": "El mismo producto con diferentes precios",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/elmismoproductocondiferentesprecios.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Explora cómo gestionar un mismo producto con distintos precios según el cliente o la promoción activa. Aprende a configurar opciones de precios variables para maximizar tus ventas. Palabras clave: productos, precios variables, ventas, promociones, gestión de precios. caja vertical",
      "clave": "productos con varios precios, estrategia ventas"
    },
    {
      "titulo": "Agregar y ajustar producto",
      "url": "https://afnarqui.s3.us-east-1.amazonaws.com/videos/agregaryajustarproducto.mp4",
      "imagen": "https://res.cloudinary.com/drqk6qzo7/image/upload/v1686420256/logo_yt4vtc.png",
      "descripcion": "Aprende a agregar un nuevo producto al sistema y realizar ajustes rápidos. Cambia el nombre del producto, ajusta el valor de venta, selecciona el tipo de impuesto y configura el valor del impuesto. Esta herramienta de 'venta rápida' facilita la creación de productos personalizados en tu inventario. Palabras clave: agregar producto, ajuste de valor, impuestos, venta rápida, caja vertical.",
      "clave": "añadir producto, modificar precio, edición productos"
    }
  ]



  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    public servicio: CajaProvider,
    public loadingCtrl: LoadingController,
    public servicioMesas: MesasProvider,
    public servicioDenominaciones: DenominacionesProvider,
    public auth: AuthService,
    public servicioCompania: CompaniasProvider,
    public platform: Platform,
    public servicioProductos: ProductosProvider,
    public servicioProductosPorGruposProvider: ProductosPorGruposProvider,
    public toastControllers: ToastController,
    public push: PushProvider,
    public utils: UtilsProvider,
    public providerClientes: ClientesProvider,
    public servicioDescargar: InformesProvider,
  ) {
    this.generarSugerencias();
    this.cargarConsultasGuardadas();
  }

  // Guardar consulta en LocalStorage
  guardarConsulta() {
    if (this.consulta.trim() === '') return;

    let consultas = JSON.parse(localStorage.getItem('consultas') || '[]');

    // Evitar duplicados y limitar el almacenamiento a 300 registros
    consultas = consultas.filter(c => c !== this.consulta);
    consultas.unshift(this.consulta);
    if (consultas.length > 300) {
      consultas = consultas.slice(0, 300);
    }

    localStorage.setItem('consultas', JSON.stringify(consultas));
    this.cargarConsultasGuardadas();
  }


  async cargarConsultasGuardadas() {
    try {
      let companiasId = await localStorage.getItem('companiasId'); // Obtener el ID de la compañía
      if (!companiasId) {
        console.error("No se encontró companiasId en localStorage");
        return;
      }

      let data = await this.utils.buscarPromptiaSeguimientos(companiasId); // Llamar a la base de datos
      let response = JSON.parse(data['_body']).data[0]
      if(response !== null) {
        // Filtrar duplicados basados en pregunta y consultasql
        const consultasUnicas = response.filter(
          (consulta, index, self) =>
            index ===
            self.findIndex(
              (c) => c.pregunta === consulta.pregunta && c.consultasql === consulta.consultasql
            )
        );

        this.consultasGuardadas = consultasUnicas; // Guardar consultas sin repetir
      } else {
        this.consultasGuardadas = []; // Si no hay datos, mantener un array vacío
      }

      this.paginarConsultas(); // Aplicar paginación
    } catch (error) {
      console.error("Error al cargar consultas guardadas:", error);
    }
  }




  // Paginar resultados
  paginarConsultas() {
    const inicio = this.paginaActual * this.tamanioPagina;
    this.consultasPaginadas = this.consultasGuardadas.slice(inicio, inicio + this.tamanioPagina);
  }

  // Cambiar página
  cambiarPagina(adelante: boolean) {
    const maxPaginas = Math.ceil(this.consultasGuardadas.length / this.tamanioPagina);
    if (adelante) {
      if (this.paginaActual < maxPaginas - 1) this.paginaActual++;
    } else {
      if (this.paginaActual > 0) this.paginaActual--;
    }
    this.paginarConsultas();
  }

  autocompletarConsulta(consulta: string, textarea: any) {
    this.consulta = consulta;
    setTimeout(() => {
      this.ajustarAltura(textarea);
    }, 10);
  }

  ajustarAncho(event: any): void {
    let inputElement = event.target; // Capturar el input de la caja de búsqueda
    this.anchoBuscador = Math.max(200, inputElement.scrollWidth); // Ajustar el ancho según el contenido
  }

  generarSugerencias() {
    this.sugerencias = [];

    this.tablasDisponibles.forEach(tabla => {
      // Agregar las tablas
      this.sugerencias.push({ nombre: tabla, tipo: 'tabla' });

      // Agregar los campos de cada tabla
      if (this.camposDisponibles[tabla]) {
        this.camposDisponibles[tabla].forEach(campo => {
          this.sugerencias.push({ nombre: `${tabla} > ${campo}`, tipo: 'campo' });
        });
      }
    });
  }



  async buscar() {
    let loading = this.loadingCtrl.create({ content: 'Consultando IA...' });
    loading.present();
    this.imagen = '';

    try {
      if (!this.consulta.trim()) {
        this.mostrarMensaje('Por favor ingresa una consulta válida');
        if (loading) {
          loading.dismiss().catch(err => console.log("Error al cerrar el loading:", err));
        }
        return;
      }

      let companiasId = await localStorage.getItem('companiasId');
      if (!companiasId) {
        console.error("No se encontró companiasId en localStorage");
        if (loading) {
          loading.dismiss().catch(err => console.log("Error al cerrar el loading:", err));
        }
        return;
      }


      // 🔹 Buscar si la consulta ya existe en consultasGuardadas
      let consultaExistente = this.consultasGuardadas.find(
        (c) => c.pregunta.trim().toLowerCase() === this.consulta.trim().toLowerCase()
      );

      if (consultaExistente) {
        // 🔹 Si la consulta ya existe, obtener datos directamente de la base de datos con el SQL guardado
        console.log("Consulta encontrada en caché, ejecutando SQL:", consultaExistente.consultasql);

        let datosDB
        if (consultaExistente.respuesta && consultaExistente.respuesta.indexOf("https") !== -1) {
          this.imagen = consultaExistente.respuesta; // Asigna la imagen si la respuesta es un enlace
          return
        } else {
          datosDB = await this.utils.buscarAFN(consultaExistente.consultasql); // Ejecuta la consulta si no hay imagen
        }
        let responseDB = JSON.parse(datosDB['_body'])

        if (responseDB && responseDB.data && responseDB.data[0].length > 0) {
          console.log("Consulta desde sql sin ir a IA...");
          this.datosDinamicos = Array.isArray(responseDB.data) ? responseDB.data[0] : [responseDB.data];
          this.columnas = Object.keys(this.datosDinamicos[0] || {});
        } else {
          this.mostrarMensaje("No se encontraron datos en la base de datos.");
        }
      } else {
        // 🔹 Si no existe, consultar a la IA
        console.log("Consulta nueva, consultando IA...");
        let datosIA = await this.utils.consultaIA(companiasId, this.consulta);
        let responseIA = datosIA && datosIA.data;

        if (responseIA && responseIA.data && responseIA.data.length > 0) {
          this.datosDinamicos = responseIA.data;
          this.columnas = Object.keys(responseIA.data[0]); // Extrae dinámicamente las claves
        } else {
          this.imagen = responseIA && responseIA.imagen || '';
        }
      }

      this.consulta = '';
    } catch (error) {
      console.error("Error en buscar():", error);
      if (loading) {
        loading.dismiss().catch(err => console.log("Error al cerrar el loading:", err));
      }
    } finally {
      if (loading) {
        loading.dismiss().catch(err => console.log("Error al cerrar el loading:", err));
      }
    }
  }

  ayuda() {
    // 🔹 Comprobar si la consulta tiene intención de buscar ayuda (videos relacionados)
    let videosFiltrados = this.filtrarVideosPorConsulta(this.consulta);
    if (videosFiltrados.length > 0) {
      this.videosRelacionados = videosFiltrados;
      return;
    }
  }

  filtrarVideosPorConsulta(consulta: string) {
    let consultaLimpia = consulta.toLowerCase().trim();
    let palabrasClave = consultaLimpia.split(" ");

    return this.listaVideos.filter(video => {
      let titulo = video.titulo.toLowerCase();
      let descripcion = video.descripcion.toLowerCase();

      return palabrasClave.some(palabra => titulo.includes(palabra) || descripcion.includes(palabra));
    });
  }

limpiar() {
  this.sugerencias = []
  this.resultado = []
  this.datosDinamicos = []
  this.consulta = ''
  this.enfocarBuscador()
  this.imagen = ''
  this.videosRelacionados = []
}

toggleImagen() {
  this.imagenAmpliada = !this.imagenAmpliada; // Alterna el estado
}

  getKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }


  ajustarAltura(textarea: any): void {
    setTimeout(() => {
      if (textarea && textarea._elementRef && textarea._elementRef.nativeElement) {
        let textAreaElement = textarea._elementRef.nativeElement.querySelector('textarea');
        textAreaElement.style.height = 'auto';
        textAreaElement.style.height = textAreaElement.scrollHeight + 'px';
      }
    }, 0);
  }


  normalizarConsulta(consulta: string): string {
    let palabras = consulta.toLowerCase().split(' ');

    // Reemplazar sinónimos de tablas
    palabras = palabras.map(palabra => {
      return this.sinonimosTablas[palabra] || palabra;
    });

    // Reemplazar sinónimos de campos
    palabras = palabras.map(palabra => {
      return this.sinonimosCampos[palabra] || palabra;
    });

    return palabras.join(' '); // Reconstruimos la consulta
  }


actualizarSugerencias(event: any, textarea: any) {
  this.ajustarAltura(textarea);
  this.sugerencias = []; // Limpiar sugerencias

  let palabras = this.consulta.trim().split(' ');

  // Reemplazar sinónimos SOLO si la palabra completa tiene un equivalente
  palabras = palabras.map(palabra =>
    this.sinonimosTablas.hasOwnProperty(palabra.toLowerCase())
      ? this.sinonimosTablas[palabra.toLowerCase()]
      : palabra
  );

  let ultimaPalabra = palabras[palabras.length - 1].toLowerCase(); // Última palabra escrita
  let sugerenciasTemporales = [];

  // Verificar si la última palabra es una tabla después de la conversión
  for (let i = 0; i < this.tablasDisponibles.length; i++) {
    let tabla = this.tablasDisponibles[i].toLowerCase();
    if (tabla === ultimaPalabra) {
      sugerenciasTemporales.push({ nombre: this.tablasDisponibles[i], tipo: 'tabla' });
    }
  }

  // Agregar tablas como sugerencias
  for (let i = 0; i < this.tablasDisponibles.length; i++) {
    let tabla = this.tablasDisponibles[i].toLowerCase();
    if (tabla.indexOf(ultimaPalabra) !== -1) {
      sugerenciasTemporales.push({ nombre: this.tablasDisponibles[i], tipo: 'tabla' });
    }
  }

  // Agregar campos como sugerencias
  for (let tabla in this.camposDisponibles) {
    if (this.camposDisponibles.hasOwnProperty(tabla)) {
      for (let i = 0; i < this.camposDisponibles[tabla].length; i++) {
        let campo = this.camposDisponibles[tabla][i].toLowerCase();
        let nombreCompleto = tabla + ' > ' + this.camposDisponibles[tabla][i];
        if (campo.indexOf(ultimaPalabra) !== -1) {
          sugerenciasTemporales.push({ nombre: nombreCompleto, tipo: 'campo' });
        }
      }
    }
  }

  // Ordenar dando prioridad a lo último escrito
  this.sugerencias = sugerenciasTemporales.sort((a, b) => {
    let indexA = a.nombre.toLowerCase().indexOf(ultimaPalabra);
    let indexB = b.nombre.toLowerCase().indexOf(ultimaPalabra);
    return indexA - indexB; // Primero los que coincidan más temprano en la palabra
  });
}

  seleccionarSugerencia(sugerencia: { nombre: string }) {
    let palabras = this.consulta.trim().split(' '); // Dividir el texto en palabras

    // Reemplazar solo la última palabra escrita con la sugerencia seleccionada
    if (palabras.length > 0) {
      palabras[palabras.length - 1] = this.obtenerNombreCampo(sugerencia.nombre); // Solo deja el campo
    } else {
      palabras.push(this.obtenerNombreCampo(sugerencia.nombre));
    }

    this.consulta = palabras.join(' '); // Reconstruir la consulta
    this.sugerencias = []; // Ocultar sugerencias
    this.enfocarBuscador(); // Llamar método para enfocar y mover el cursor
  }

  // Obtener solo el nombre del campo (sin la tabla)
  obtenerNombreCampo(nombreCompleto: string): string {
    let partes = nombreCompleto.split(' > ');
    return partes[partes.length - 1]; // Devuelve solo el campo
  }

// Método para enfocar el input y mover el cursor al final
enfocarBuscador() {
  setTimeout(() => {
    if (this.inputBuscador) {
      this.inputBuscador.setFocus(); // Asegura el foco en el textarea

      let textAreaElement = this.inputBuscador._elementRef.nativeElement.querySelector('textarea');
      textAreaElement.selectionStart = textAreaElement.selectionEnd = textAreaElement.value.length; // Cursor al final
    }
  }, 100);
}



  descargarExcel() {
    console.log('Descargando Excel...');
  }

  mostrarMensaje(mensaje: string) {
    let toast = this.toastControllers.create({
      message: mensaje,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }
  toggleHistorial() {
    this.mostrarHistorial = !this.mostrarHistorial;

    if (this.mostrarHistorial) {
      this.sugerencias = []
      setTimeout(() => {
        const historial = document.querySelector('.historial-container');
        if (historial) {
          historial.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
      }, 10); // Esperamos un corto tiempo para que Angular termine de renderizar
    }
  }
  async ionViewDidLoad() {

    let datosGenerales = localStorage.getItem('datosGenerales')
    let datosGeneralesJSON = JSON.parse(datosGenerales)
    if(datosGeneralesJSON && datosGeneralesJSON["consultasIa"]) {
      this.consultasIa = datosGeneralesJSON["consultasIa"].seleccion === 'S' ? true : false
    }
    if(!this.consultasIa) {
      this.utils.mensajeMuestroConCerrado('IA','El módulo de IA NO ESTA ACTIVO valide con su administrador...', 'warning',true)
      this.navCtrl.push(HomePage)
    }
  }

  descargarData(data:any,nombre:any) {
    this.servicioDescargar.exportToExcel(data, nombre);
  }
  atras(){

    this.navCtrl.setRoot('HomePage');
  }

  // toggleAmpliarImagen(index: number) {
  //   this.imagenesAmpliadas[index] = !this.imagenesAmpliadas[index];
  // }

  ampliarImagen(imagen: string) {
    this.imagenAmpliadaDos = imagen; // Almacena la imagen seleccionada
  }

  cerrarImagen() {
    this.imagenAmpliadaDos = null; // Cierra la imagen al hacer clic fuera
  }

}

interface ConsultaGuardada {
  promptiaSeguimientosId: number;
  companiasId: number;
  pregunta: string;
  respuesta: string;
  consultasql: string;
}



// WEBPACK FOOTER //
// ./src/components/ia/ia.ts